import React from "react";

export const createTheme = (options = {}) => options;

export const ThemeProvider = ({ theme, children }) => (
  <>{children}</>
);
